var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeFlower1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 667 667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.458 262.337C353.137 264.411 343.446 265.505 333.5 265.505C323.554 265.505 313.864 264.411 304.542 262.337C293.855 279.397 279.398 293.855 262.337 304.542C264.411 313.864 265.505 323.554 265.505 333.5C265.505 343.157 264.474 352.574 262.515 361.645C279.439 372.284 293.791 386.637 304.43 403.56C313.501 401.601 322.918 400.57 332.575 400.57C342.631 400.57 352.425 401.688 361.841 403.807C372.514 386.432 387.074 371.702 404.311 360.829C402.465 352.009 401.495 342.868 401.495 333.5C401.495 323.554 402.589 313.863 404.663 304.542C387.603 293.855 373.145 279.398 362.458 262.337ZM62.3746 220.917C24.912 244.385 0 286.033 0 333.5C0 380.891 24.8331 422.483 62.1965 445.971C60.2382 455.042 59.207 464.459 59.207 474.116C59.207 547.433 118.642 606.869 191.959 606.869C201.617 606.869 211.033 605.837 220.104 603.879C243.593 641.242 285.184 666.075 332.575 666.075C380.46 666.075 422.423 640.722 445.774 602.707C455.19 604.825 464.985 605.943 475.041 605.943C548.358 605.943 607.793 546.508 607.793 473.191C607.793 463.823 606.823 454.681 604.977 445.862C642.244 422.354 667 380.818 667 333.5C667 286.033 642.088 244.385 604.625 220.917C606.699 211.596 607.793 201.905 607.793 191.959C607.793 118.642 548.358 59.207 475.041 59.207C465.095 59.207 455.404 60.3008 446.083 62.3745C422.615 24.912 380.967 0 333.5 0C286.034 0 244.386 24.9121 220.918 62.3747C211.596 60.3008 201.906 59.207 191.959 59.207C118.642 59.207 59.207 118.642 59.207 191.959C59.207 201.905 60.3008 211.596 62.3746 220.917Z",
    fill: "url(#paint0_linear_1248_697)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1248_697",
    x1: 333.5,
    y1: -1.49219e-8,
    x2: 334,
    y2: 689.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7130C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090714"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeFlower1);
export default __webpack_public_path__ + "static/media/shape_flower_1.0f4676793a30af25a06e5234696328c8.svg";
export { ForwardRef as ReactComponent };